import React from 'react';
import packageJson from '../../../package.json';

export default function LabelVersao() {
    return (
        <p className="text-muted" style={{ fontSize: '12px' }}>
            Versão {packageJson.version}
        </p>
    );
}